import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Typography,
  Button,
  Modal,
  Input,
  Upload,
  notification,
  message,
} from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import { StyledLayout } from '$globalStyledComponents/Layout'
import Footer from '$components/Footer'
import Topwelcomecard from './Topwelcomecard'
import Materialmapper from './MaterialMapper'
import { useMutation } from '@tanstack/react-query'
import { suggestDwhMaterial } from '$api/evoAPIs'
import { checkFileSize } from '$utils'
import Form from '$components/Form'

const { Content } = StyledLayout
const { Title } = Typography
const { TextArea } = Input

const Mymaterials = () => {
  const { t } = useTranslation()
  const [isSuggestModalOpen, setIsSuggestModalOpen] = useState(false)
  const [suggestForm] = Form.useForm()

  const suggestMaterialMutation = useMutation({
    mutationFn: suggestDwhMaterial,
    onSuccess: () => {
      notification.success({
        message: t('my_materials.suggestion_sent_success'),
        description: t('my_materials.suggestion_sent_description'),
      })
      setIsSuggestModalOpen(false)
      suggestForm.resetFields()
    },
    onError: (error) => {
      console.error(error)
      notification.error({
        message: t('error_sending_suggestion'),
      })
    },
  })

  const handleSuggestClick = () => {
    setIsSuggestModalOpen(true)
  }

  const handleSuggestCancel = () => {
    setIsSuggestModalOpen(false)
    suggestForm.resetFields()
  }

  const handleSuggestSubmit = async (values) => {
    const formData = new FormData()
    formData.append('name', values.name)
    formData.append('description', values.description)

    if (values.file && values.file.length > 0) {
      formData.append('file', values.file[0].originFileObj)
    }

    suggestMaterialMutation.mutate(formData)
  }

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e
    }
    return e?.fileList
  }

  const beforeUpload = (file) => {
    if (!checkFileSize(file.size, '10 MB', t)) return Upload.LIST_IGNORE

    const isAllowedType =
      file.type === 'application/pdf' ||
      file.type === 'image/png' ||
      file.type === 'image/jpeg' ||
      file.type === 'image/jpg'

    if (!isAllowedType) {
      message.error(
        t(
          'my_materials.file_type_error',
          'You can only upload PDF, PNG, or JPG files!',
        ),
      )
      return Upload.LIST_IGNORE
    }

    return false
  }

  return (
    <StyledLayout className="layout">
      <Content>
        <Title level={1} style={{ margin: '50px 0' }}>
          {t('my_materials_title')}
        </Title>

        <Topwelcomecard handleSuggestClick={handleSuggestClick} />

        <div className="contentcard" style={{ marginTop: '24px' }}>
          <Materialmapper />
        </div>

        <Modal
          title={t('my_materials.suggest_material_title')}
          open={isSuggestModalOpen}
          onCancel={handleSuggestCancel}
          footer={null}
        >
          <p>{t('my_materials.suggest_material_intro')}</p>
          <Form
            form={suggestForm}
            layout="vertical"
            onFinish={handleSuggestSubmit}
          >
            <Form.Item
              name="name"
              label={t('my_materials.material_name')}
              rules={[{ required: true, message: t('field_required') }]}
            >
              <Input
                placeholder={t('my_materials.material_name_placeholder')}
              />
            </Form.Item>
            <Form.Item
              name="description"
              label={t('description_column')}
              rules={[{ required: true, message: t('field_required') }]}
            >
              <TextArea
                rows={4}
                placeholder={t('my_materials.material_description_placeholder')}
              />
            </Form.Item>
            <Form.Item
              name="file"
              label={t('specification_column')}
              valuePropName="fileList"
              getValueFromEvent={normFile}
              extra={t('my_materials.upload_hint', 'Max 10MB. PDF, PNG, JPG.')}
            >
              <Upload
                name="file"
                maxCount={1}
                beforeUpload={beforeUpload}
                accept=".pdf,.png,.jpg,.jpeg"
                listType="text"
              >
                <Button icon={<UploadOutlined />}>
                  {t('upload_spec_button')}
                </Button>
              </Upload>
            </Form.Item>
            <div style={{ textAlign: 'right', marginTop: '20px' }}>
              <Button onClick={handleSuggestCancel} style={{ marginRight: 8 }}>
                {t('button.cancel')}
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={suggestMaterialMutation.isLoading}
              >
                {t('upload_spec_button')}
              </Button>
            </div>
          </Form>
        </Modal>
      </Content>
      <Footer />
    </StyledLayout>
  )
}

export default Mymaterials
